import { render, staticRenderFns } from "./PromotionTipsSmall.vue?vue&type=template&id=564e81b3&scoped=true"
import script from "./PromotionTipsSmall.vue?vue&type=script&lang=js"
export * from "./PromotionTipsSmall.vue?vue&type=script&lang=js"
import style0 from "./PromotionTipsSmall.vue?vue&type=style&index=0&id=564e81b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564e81b3",
  null
  
)

export default component.exports